export default function Reducer(prevState, action) {
    switch (action.type) {
        case 'IS_LOADING':
            return {
                ...prevState,
                is_loading: true,
            };
        case 'IS_LOADED':
            return {
                ...prevState,
                is_loading: false,
                credit_notes: action.credit_notes,
                total_credit_notes: action.total_credit_notes,
                total_pages: action.total_pages,
            };
        case 'SET_CURRENT_PAGE':
            return {
                ...prevState,
                current_page: action.current_page,
            };
        default:
            throw new Error();
    }
}